import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TextMessageBuilderFormComponent } from './text-message-builder-form/text-message-builder-form.component';
import { TextMessageBuilderPreviewComponent } from './text-message-builder-preview/text-message-builder-preview.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { TextMessageBuilderForm } from './interfaces';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  standalone: true,
  selector: 'sms-builder',
  templateUrl: 'text-message-builder.component.html',
  styleUrls: ['./text-message-builder.component.scss'],
  imports: [MatCardModule, CommonModule, TextMessageBuilderFormComponent, TextMessageBuilderPreviewComponent],
})
export class TextMessageBuilderComponent implements OnInit {
  initialInputText: TextMessageBuilderForm = { message: '', name: '' };
  private sms$$: BehaviorSubject<TextMessageBuilderForm> = new BehaviorSubject<TextMessageBuilderForm>({
    name: '',
    message: '',
  });
  sms$: Observable<TextMessageBuilderForm> = this.sms$$.asObservable();

  private valid$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  valid$: Observable<boolean> = this.valid$$.asObservable();

  @Input() allowDynamic: boolean;

  @Input()
  set setMessageBuilderText(messageBuilderText: TextMessageBuilderForm) {
    if (messageBuilderText) {
      this.initialInputText = messageBuilderText;
    }
  }

  @Output() sms: EventEmitter<TextMessageBuilderForm> = new EventEmitter();
  @Output() valid: EventEmitter<boolean> = new EventEmitter();

  ngOnInit() {
    this.sms$.subscribe((value) => {
      this.sms.emit(value as TextMessageBuilderForm);
    });
    this.valid$.subscribe((status) => {
      this.valid.emit(status);
    });
  }

  updateSMS(m: TextMessageBuilderForm) {
    this.sms$$.next(m);
  }

  updateValid(m: boolean) {
    this.valid$$.next(m);
  }
}
